import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import SidebarToggle from "../../components/sidebar-toggle-button/sidebar-toggle-button";
import { getTaggingFunc } from "../../helpers/dataLayerData";
import SidebarContent from "./sidebar-content";

function SidebarWrapper(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const drawerDefaultLoading = props.drawerDefaultLoading
  const sidebarBtnTextColor = props.collapsedDrawerTextColor

  useEffect(() => {
    //drawerDefaultLoading === 'open' ? setIsSidebarOpen(!isSidebarOpen) : setIsSidebarOpen(isSidebarOpen) //initially sidebar close/open dynamic
    drawerDefaultLoading === 'open' ? setIsSidebarOpen(isSidebarOpen) : setIsSidebarOpen(isSidebarOpen) //initially sidebar close 
  }, [drawerDefaultLoading])

  let drawerStatus = null
  isSidebarOpen === false ? drawerStatus = 'Open': drawerStatus = 'Close'

  const sidebarToggle = () => {
    getTaggingFunc("mobile" , drawerStatus, `${drawerStatus} Drawer`, 'Side')
    setIsSidebarOpen(!isSidebarOpen);
    props.setDefaultIntervalFunc()
  };

  return (
    props.sideDrawerTitle ? 
    <Fragment>
      <SidebarToggle
        sidebarToggle={sidebarToggle}
        drawerBgColor={props.drawerBgColor}
        defaultBgColor={props.defaultBgColor}
        sideDrawerTitle={props.sideDrawerTitle}
        sidebarBtnTextColor ={sidebarBtnTextColor}
        drawerSessionTimeoutValue ={props.drawerSessionTimeoutValue}
        drawerSessionType={props.drawerSessionType}
      />
        <SidebarContent
          isSidebarOpen={isSidebarOpen}
          sidebarToggle={sidebarToggle}
          contentSliderDataArr={props.contentSliderDataArr}
          drawerBgColor={props.drawerBgColor}
          defaultBgColor={props.defaultBgColor}
          //screenStatus={props.screenStatus}
          drawerDefaultLoading = {drawerDefaultLoading}
        />
    </Fragment>
    : null
  );
}

export default React.memo(SidebarWrapper)
